import { isAgentUser } from '../../auth/loginDestination';
import { kstDate } from './data';

export function isEarningsDemo(user, api = process.env.REACT_APP_API, ids = process.env.REACT_APP_AGENT_DASHBOARD_DEMO_IDS) {
    // .env is inherited by tenant builds: never let its demo opt-in leak to a live API.
    if (api?.replace(/\/$/, '') !== 'https://paybase-aa.t4t4.kr' || !isAgentUser(user)) return false;
    const id = user?.agent_id;
    return id != null && String(ids || '').split(',').map(s => s.trim()).filter(Boolean).includes(String(id));
}
export function demoSummary(selection, now = new Date()) {
    const today = kstDate(now);
    const midnight = Date.parse(`${today}T00:00:00+09:00`);
    const dayMs = 86400000;
    const weekDay = new Date(`${today}T00:00:00Z`).getUTCDay();
    const weekStart = midnight - ((weekDay + 6) % 7) * dayMs;
    const monthStart = Date.parse(`${today.slice(0, 7)}-01T00:00:00+09:00`);
    // Deterministic variation: revisiting the page must not randomly change past earnings.
    const hourlyWeights = [3, 2, 1, 1, 2, 4, 8, 19, 32, 26, 41, 66, 83, 58, 39, 47, 35, 62, 76, 54, 31, 18, 11, 6];
    const dayAmount = time => {
        if (time === midnight) return 128500;
        const local = new Date(time + 9 * 3600000);
        const seed = Math.floor(time / dayMs);
        const variation = ((seed * 37 + 17) % 41) / 100 + .8;
        const weekday = [0.73, 0.96, 1.08, 0.91, 1.13, 1.32, 1.18][local.getUTCDay()];
        return Math.round(186000 * variation * weekday / 100) * 100;
    };
    const sum = start => { let n = 0; for (let t = start; t <= midnight; t += dayMs) n += dayAmount(t); return n; };
    const start = selection.period === 'week' ? weekStart : selection.period === 'month' ? monthStart : midnight;
    const trend = [];
    if (selection.period === 'today') {
        const hours = Math.floor((now.getTime() - midnight) / 3600000) + 1;
        let previous = 0;
        let weight = 0;
        const totalWeight = hourlyWeights.slice(0, hours).reduce((n, value) => n + value, 0);
        for (let h = 0; h < hours; h++) {
            weight += hourlyWeights[h];
            const cumulative = Math.round(128500 * weight / totalWeight);
            trend.push({ bucket_start: new Date(midnight + h * 3600000).toISOString(), label: `${h}시`, earnings: cumulative - previous });
            previous = cumulative;
        }
    } else for (let t = start; t <= midnight; t += dayMs) trend.push({ bucket_start: new Date(t).toISOString(), label: kstDate(new Date(t)).slice(5).replace('-', '/'), earnings: dayAmount(t) });
    return { timezone: 'Asia/Seoul', as_of: now.toISOString(), range: { start_at: new Date(start).toISOString(), end_at: now.toISOString(), label: `${kstDate(new Date(start))} 00:00 ~ 현재`, bucket: selection.period === 'today' ? 'hour' : 'day' }, summary: { earnings: trend.reduce((n, p) => n + p.earnings, 0), transaction_count: 86, merchant_count: 12 }, totals: { week_earnings: sum(weekStart), month_earnings: sum(monthStart) }, comparison: null, trend, top_merchants: [] };
}
